import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = { class: "page-container card col-md-8" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "RPK", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "CWK", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Journal", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "row p-3 pb-0" }, [
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Search existing report by:")
  ])
], -1)
const _hoisted_11 = { class: "row p-3 pb-0" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "row p-3" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_17 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { class: "col-md-9" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "d-flex align-items-center col-md-12" }
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = { class: "col-md-9" }
const _hoisted_24 = { class: "row p-3" }
const _hoisted_25 = { class: "col-md-5 d-flex align-items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_27 = { class: "col-md-7" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-12 p-4" }
const _hoisted_30 = { class: "p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12" }
const _hoisted_31 = { class: "p-datatable-thead" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"5%"} }, "#", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("th", {
  style: {"width":"27%"},
  class: "text-center"
}, "Action", -1)
const _hoisted_34 = {
  key: 0,
  class: "p-datatable-tbody"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "text-right" }
const _hoisted_38 = { class: "row p-0" }
const _hoisted_39 = { class: "col-md-10 p-0" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_41 = { class: "col-md-2 p-0" }
const _hoisted_42 = {
  key: 0,
  class: "error-no-record"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_TheTabViewLoading = _resolveComponent("TheTabViewLoading")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_TheTableLoading = _resolveComponent("TheTableLoading")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ThePageHeader),
              (_ctx.pageError == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_TabView, { onTabChange: _ctx.setIndex }, {
                      default: _withCtx(() => [
                        _createVNode(_component_TabPanel, null, {
                          header: _withCtx(() => [
                            _hoisted_7
                          ]),
                          default: _withCtx(() => [
                            (_ctx.isPageLoading)
                              ? (_openBlock(), _createBlock(_component_TheTabViewLoading, { key: 0 }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        (_ctx.isAdmin || _ctx.isHQStaff || _ctx.isViewer)
                          ? (_openBlock(), _createBlock(_component_TabPanel, { key: 0 }, {
                              header: _withCtx(() => [
                                _hoisted_8
                              ]),
                              default: _withCtx(() => [
                                (_ctx.isPageLoading)
                                  ? (_openBlock(), _createBlock(_component_TheTabViewLoading, { key: 0 }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.isAdmin || _ctx.isHQStaff || _ctx.isViewer)
                          ? (_openBlock(), _createBlock(_component_TabPanel, { key: 1 }, {
                              header: _withCtx(() => [
                                _hoisted_9
                              ]),
                              default: _withCtx(() => [
                                (_ctx.isPageLoading)
                                  ? (_openBlock(), _createBlock(_component_TheTabViewLoading, { key: 0 }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["onTabChange"]),
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_Calendar, {
                          dateFormat: "yy-mm-dd",
                          selectionMode: "range",
                          manualInput: true,
                          placeholder: "Balance Sheet Date (range)",
                          modelValue: _ctx.filterBalanceSheetDateModel,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterBalanceSheetDateModel) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_InputText, {
                          class: "p-inputtext",
                          type: "text",
                          maxlength: "50",
                          placeholder: "File ID",
                          modelValue: _ctx.filterFileIdModel.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterFileIdModel.value) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_Dropdown, {
                          options: _ctx.applicationStatuses,
                          optionLabel: "name",
                          optionValue: "value",
                          placeholder: "Status",
                          modelValue: _ctx.filterStatusModel.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterStatusModel.value) = $event))
                        }, null, 8, ["options", "modelValue"])
                      ]),
                      (_ctx.activeTabIndex == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_component_Dropdown, {
                              options: _ctx.companies,
                              optionLabel: "code",
                              optionValue: "code",
                              filter: "",
                              filterFields: ['code', 'name'],
                              showClear: "",
                              placeholder: _ctx.isCompanyLoading ? ('Loading...') : 'Company',
                              loading: _ctx.isCompanyLoading,
                              modelValue: _ctx.filterCompanyModel.value,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterCompanyModel.value) = $event))
                            }, {
                              value: _withCtx((slotProps) => [
                                (slotProps.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                      _createElementVNode("span", _hoisted_18, _toDisplayString(slotProps.value), 1),
                                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.filterCompanyNameByValue(slotProps.value)), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(slotProps.placeholder), 1))
                              ]),
                              option: _withCtx((slotProps) => [
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("span", _hoisted_22, _toDisplayString(slotProps.option.code), 1),
                                  _createElementVNode("span", _hoisted_23, _toDisplayString(slotProps.option.name), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["options", "placeholder", "loading", "modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_Button, {
                          class: "p-button-sm",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.find(1, _ctx.activeTabIndex))),
                          label: "Search",
                          disabled: _ctx.pageError != '' 
                        }, null, 8, ["disabled"]),
                        _hoisted_26,
                        _createVNode(_component_Button, {
                          class: "p-button-sm p-button-secondary",
                          label: "Reset",
                          onClick: _ctx.reset,
                          disabled: _ctx.pageError != ''
                        }, null, 8, ["onClick", "disabled"])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        (_ctx.pagination.currentPage != 0)
                          ? (_openBlock(), _createBlock(_component_Paginator, {
                              key: 0,
                              first: _ctx.paginator,
                              pageLinkSize: 3,
                              rows: _ctx.pagination.itemsPerPage,
                              totalRecords: _ctx.pagination.totalItems,
                              onPage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.find($event.page + 1, _ctx.activeTabIndex)))
                            }, null, 8, ["first", "rows", "totalRecords"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("table", _hoisted_30, [
                          _createElementVNode("thead", _hoisted_31, [
                            _createElementVNode("tr", null, [
                              _hoisted_32,
                              _createElementVNode("th", {
                                style: {"width":"16%","cursor":"pointer"},
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sort('x.fileId')))
                              }, [
                                _createTextVNode("File ID "),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.fileId' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                }, null, 2)
                              ]),
                              (_ctx.activeTabIndex == 0)
                                ? (_openBlock(), _createElementBlock("th", {
                                    key: 0,
                                    style: {"width":"25%","cursor":"pointer"},
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sort('x.companyName')))
                                  }, [
                                    _createTextVNode("Company"),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.companyName' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                    }, null, 2)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.activeTabIndex == 1 || _ctx.activeTabIndex == 2)
                                ? (_openBlock(), _createElementBlock("th", {
                                    key: 1,
                                    style: {"width":"25%","cursor":"pointer"},
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sort('x.consoGroupName')))
                                  }, [
                                    _createTextVNode("Conso Group"),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.consoGroupName' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                    }, null, 2)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("th", {
                                style: {"width":"17%","cursor":"pointer"},
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sort('x.balanceSheetDate')))
                              }, [
                                _createTextVNode("Balance Sheet Date "),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.balanceSheetDate' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                }, null, 2)
                              ]),
                              _createElementVNode("th", {
                                style: {"width":"10%","cursor":"pointer"},
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sort('x.status')))
                              }, [
                                _createTextVNode("Status "),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.status' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                }, null, 2)
                              ]),
                              _hoisted_33
                            ])
                          ]),
                          (!_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("tbody", _hoisted_34, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagination.reports, (report, index) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                    _createElementVNode("td", null, _toDisplayString(((_ctx.pagination.currentPage - 1) * _ctx.pagination.itemsPerPage) + index + 1), 1),
                                    _createElementVNode("td", null, _toDisplayString(report.fileId), 1),
                                    (_ctx.activeTabIndex == 0)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_35, _toDisplayString(report.companyName), 1))
                                      : _createCommentVNode("", true),
                                    (_ctx.activeTabIndex == 1 || _ctx.activeTabIndex == 2)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString(report.consoGroupName), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("td", null, _toDisplayString(report.balanceSheetDate), 1),
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_Badge, {
                                        class: _normalizeClass(["mr-2", [report.status == 'Accepted' || report.status == 'Finalised' || report.status == 'Consolidated' ? 'p-badge-success' : (report.status == 'Rejected' || report.status == 'Cancelled' ? 'p-badge-danger' : (report.status == 'Submitted' ? 'p-badge-primary' : 'p-badge-warning'))]]),
                                        value: report.status
                                      }, null, 8, ["class", "value"])
                                    ]),
                                    _createElementVNode("td", _hoisted_37, [
                                      _createElementVNode("div", _hoisted_38, [
                                        _createElementVNode("div", _hoisted_39, [
                                          (report.fileId.startsWith('CW-'))
                                            ? (_openBlock(), _createBlock(_component_Button, {
                                                key: 0,
                                                type: "button",
                                                class: "p-button-sm",
                                                label: "Elimination",
                                                onClick: ($event: any) => (_ctx.generate(report)),
                                                disabled: _ctx.isGenerateLoadingId != -1 || _ctx.isExportingLoadingId != -1
                                              }, null, 8, ["onClick", "disabled"]))
                                            : _createCommentVNode("", true),
                                          _hoisted_40,
                                          (report.fileId.startsWith('RP-') || report.fileId.startsWith('CW-'))
                                            ? (_openBlock(), _createBlock(_component_Button, {
                                                key: 1,
                                                class: "p-button-sm",
                                                icon: "pi pi-external-link",
                                                label: "Export",
                                                onClick: ($event: any) => (_ctx.exportFile(report)),
                                                disabled: _ctx.isExportingLoadingId != -1 || _ctx.isGenerateLoadingId != -1
                                              }, null, 8, ["onClick", "disabled"]))
                                            : _createCommentVNode("", true),
                                          (report.fileId.startsWith('CJ-'))
                                            ? (_openBlock(), _createBlock(_component_SplitButton, {
                                                key: 2,
                                                class: "p-button-sm",
                                                icon: "pi pi-file-export",
                                                label: "Export",
                                                model: _ctx.getExportJournalItems(report),
                                                id: 'splitButton'+report.fileId,
                                                onClick: ($event: any) => (_ctx.splitButton(report.fileId))
                                              }, null, 8, ["model", "id", "onClick"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_41, [
                                          (_ctx.isExportingLoadingId == report.fileId || _ctx.isGenerateLoadingId == report.fileId)
                                            ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (!_ctx.isLoading && _ctx.pagination.reports.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createVNode(_component_FontAwesomeIcon, {
                              icon: ['fas', 'image'],
                              size: "2x"
                            }),
                            _hoisted_43
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isLoading)
                        ? (_openBlock(), _createBlock(_component_TheTableLoading, { key: 1 }))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.pageError != '')
                ? (_openBlock(), _createBlock(_component_ThePageError, {
                    key: 1,
                    onBackEvent: _ctx.cancel,
                    pageError: _ctx.pageError
                  }, null, 8, ["onBackEvent", "pageError"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ])
  ], 64))
}